<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Axe Animation" />
            <AxeAnimation />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import AxeAnimation from '../AxeAnimation/AxeAnimation.vue'

export default {
    name: 'AxeAnimationPage',
    components: {
        NavBar,
        PageTitle,
        AxeAnimation,
        FooterComp,
    }
}
</script>